<script>
    import {onMount} from 'svelte';
    import {goto} from '$app/navigation';

    import {app_url} from '$lib/svelte_1848_settings.js';
    import arrow_right from '../routes/arrow-right.svg';
    import checkmark from './checkmark-large.svg';

    let register;

    onMount(() => {
        const modal = document.getElementById('call-to-action')
        // If the user clicked on the 'register' button wait until the modal is
        // hidden, then go to the registreer page
        modal.addEventListener('hidden.bs.modal', event => {
            if (register) {
                goto(`${app_url}registreer`);
            }
        })
    });
</script>

<div class="modal fade" id="call-to-action" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="call-to-action-label" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="bg-gold">
                <button class="btn-close float-end pt-4 pe-4" aria-label="Sluiten" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-header bg-gold">

                <div id="call-to-action-label" class="modal-title">
                    <h2>Je maakt nu gebruik van de basis versie van het 1848 dashboard</h2>
                    <p class="mb-0">Voor slechts <span>€100</span> per maand krijg je extra functionaliteiten en diensten die het effectief volgen van de politiek nog eenvoudiger maken.</p>
                </div>
            </div>
            <div class="modal-body">
                <table class="table table-borderless text-center">
                    <thead class="mb-5">
                        <tr>
                            <th scope="col">
                                <span class="bg-light-blue4 rounded-pill large-badge">
                                    BASIS
                                </span>
                                <br>
                            </th>
                            <th scope="col"></th>
                            <th scope="col">
                                <span class="bg-gold rounded-pill large-badge">
                                    PRO
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><img src={checkmark} class="checkmark" alt="Basis: ja"></td>
                            <td>Volg live het politieke nieuws</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td><img src={checkmark} class="checkmark" alt="Basis: ja"></td>
                            <td>Makkelijk zoeken in politieke documenten</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Eigen dossiers aanmaken</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Directe notificaties</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Inzicht in de politieke agenda</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Persoonlijk dashboard</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>Volledige ondersteuning 1848 team</td>
                            <td><img src={checkmark} class="checkmark" alt="Pro: ja"></td>
                        </tr>
                    </tbody>
                </table>

                <hr class="mt-4">
                <p id="per-maand" class="text-dark-blue float-end mb-0">Maar <span>€100</span> per maand</p>
            </div>
            <div class="modal-footer">
                <div class="container gx-0 m-0">
                    <div class="row gx-0">
                        <div class="col-6">
                            <button type="button" class="btn-medium bg-dark-blue text-white me-2 me-sm-3 mt-1" data-bs-dismiss="modal">Blijf basis gebruiken</button>
                        </div>
                        <div class="col-6 d-flex">
                            <button type="button" on:click={() => register = true} data-bs-dismiss="modal" class="ms-auto btn-medium bg-gold text-center" style="box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px 0px; padding-top: 17px; padding-bottom: 16px;">
                                Probeer 30 dagen <span style="white-space: nowrap">gratis<img src={arrow_right} alt="" style="margin-left: 7px; position: relative; top: -1px" width="18.85" height="15.75"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style lang="scss">
    .modal-header {
        padding: 6px 100px 35px;
        border-radius: 0;
        text-align: center;

        h2 {
            font-size: 40px !important;
            line-height: 46px !important;
        }

        p {
            font-size: 22px !important;
            line-height: 28.6px !important;
            font-weight: 400 !important;

            span {
                font-size: 32px !important;
                line-height: 28.6px !important;
                font-weight: bold !important;
            }
        }
    }

    :global(#call-to-action .modal-body) {
        padding-top: 38px !important;
        padding-bottom: 30px !important;
    }

    .large-badge {
        padding: 10px 28px;
        font-weight: bold;
        line-height: 39px;
        word-break: normal;
    }

    th {
        padding-bottom: 27px;
    }

    tbody tr {
        background-color: var(--light-blue-color2);
        font-family: var(--font-amaranth);
        font-size: 22px !important;
        line-height: 22px !important;
        font-weight: normal !important;

        &:nth-child(2n) {
            background-color: white;
        }
    }

    td {
        padding-top: 16px;
        padding-bottom: 16px;
    }

    #per-maand {
        padding-right: 15px;
        font-size: 18px;
        line-height: 28.6px;
        font-weight: normal;

        span {
            font-size: 26px;
            font-weight: bold;
        }
    }

    .modal-header, .modal-footer {
        border: none;
    }

    .checkmark {
        width: 21.2833px;
        height: 23.8667px;
    }

    @media (max-width: 991px) {
        .modal-header {
            padding-left: 50px;
            padding-right: 50px;
        }

        :global(#call-to-action .modal-body) {
            padding-left: 10px !important;
            padding-right: 10px !important;
        }

        :global(#call-to-action .modal-footer) {
            padding-left: 10px !important;
            padding-right: 10px !important;
        }
    }

    @media (max-width: 575px) {
        .modal-header {
            padding: 0 20px 25px;

            h2 {
                font-size: 34px !important;
                line-height: 36px !important;
            }

            p {
                font-size: 18px !important;
                line-height: 24px !important;
                font-weight: 400 !important;

                span {
                    font-size: 28px !important;
                    line-height: 24px !important;
                    font-weight: bold !important;
                }
            }
        }

        tbody tr {
            font-size: 18px !important;
            line-height: 18px !important;
        }

        .large-badge {
            padding-left: 20px;
            padding-right: 20px;
        }

        #per-maand {
            padding-right: 0;
            font-size: 16px;

            span {
                font-size: 24px;
                font-weight: bold;
            }
        }
    }
</style>
